import {insertIcon} from "../utils/iconUtils";
import {createElement} from "../utils/elementUtils";

export const insertStockAvailabilityPill = (stockAvailabilityStatus, product) => {
    if (["IN_STOCK", "LOW_STOCK", "AVAILABLE_TO_ORDER", "UNAVAILABLE"].includes(stockAvailabilityStatus.availability) === false) {
        return;
    }

    const stockAvailabilityPill = createElement("div", "stock-availability-pill")
    const stockAvailabilityIconWrapper = createElement("div", "stock-availability-icon-wrapper")
    stockAvailabilityPill.appendChild(stockAvailabilityIconWrapper)

    switch (stockAvailabilityStatus.availability) {
        case "IN_STOCK":
            stockAvailabilityPill.classList.add("in-stock")
            insertTick(stockAvailabilityIconWrapper)
            break
        case "LOW_STOCK":
            stockAvailabilityPill.classList.add("low-stock")
            insertExclamation(stockAvailabilityIconWrapper)
            break
        case "AVAILABLE_TO_ORDER":
            stockAvailabilityPill.classList.add("available-to-order")
            insertExclamation(stockAvailabilityIconWrapper)
            break
        case "UNAVAILABLE":
            stockAvailabilityPill.classList.add("not-available")
            insertXMark(stockAvailabilityIconWrapper)
            break
    }
    insertLabel(stockAvailabilityPill, stockAvailabilityStatus.availabilityDescription)

    const oldStockAvailabilityPill = product.querySelector(".stock-availability-pill")
    if (oldStockAvailabilityPill) {
        oldStockAvailabilityPill.remove()
    }
    product.querySelector(".pill-container").appendChild(stockAvailabilityPill)
}

const insertTick = (stockAvailabilityIconWrapper) => {
    insertIcon(stockAvailabilityIconWrapper, "12", "10", "M3.99993 7.79994L1.19993 4.99994L0.266602 5.93328L3.99993 9.66661L11.9999 1.66661L11.0666 0.733276L3.99993 7.79994Z")
}

const insertExclamation = (stockAvailabilityIconWrapper) => {
    insertIcon(stockAvailabilityIconWrapper, "2", "11", "M0 8.5H2V10.5H0V8.5ZM0 0.5H2V6.5H0V0.5Z")
}

const insertXMark = (stockAvailabilityIconWrapper) => {
    insertIcon(stockAvailabilityIconWrapper, "10", "9", "M2.17154 0.257385L0.757324 1.6716L3.58575 4.50003L0.757324 7.32845L2.17154 8.74267L4.99996 5.91424L7.82839 8.74267L9.24261 7.32845L6.41418 4.50003L9.24261 1.6716L7.82839 0.257385L4.99996 3.08581L2.17154 0.257385Z")
}

const insertLabel = (stockAvailabilityPill, labelName) => {
    const stockAvailabilityLabel = document.createElement("span")
    stockAvailabilityLabel.innerText = labelName
    stockAvailabilityPill.appendChild(stockAvailabilityLabel)
}